import { PictureAutomobilePlatformDetail } from "../domain/PictureAutomobilePlatform.model";
import { PictureAutomobilePlatformDetailApi } from "../infrastructure/models/picture-automobile-platform-api.model";


export function SetMapPictureAutomobilePlatformDetails(
    pictureAutomobilePlatformDetails: PictureAutomobilePlatformDetailApi[]
): PictureAutomobilePlatformDetail[] {
    return pictureAutomobilePlatformDetails.map(SetMapPictureAutomobilePlatformDetail);
}

export function SetMapPictureAutomobilePlatformDetail(
    pictureAutomobilePlatformDetail: PictureAutomobilePlatformDetailApi
): PictureAutomobilePlatformDetail {
    const {
        ID,
        CreatedAt,
        UpdatedAt,
        DeletedAt,
        automobilePlatformId,
        orientationAutomobilePlatformId,
        path,
        isLoad,
        createdBy,
        updatedBy,
        orientation,
        vin,
        ...rest
    } = pictureAutomobilePlatformDetail;

    return {
        id: ID,
        createdAt: CreatedAt,
        updatedAt: UpdatedAt,
        deletedAt: DeletedAt,
        automobilePlatformId: automobilePlatformId,
        orientationAutomobilePlatformId: orientationAutomobilePlatformId,
        path: path,
        isLoad: isLoad,
        createdBy: createdBy,
        updatedBy: updatedBy,
        orientation: orientation,
        vin: vin,
        ...rest
    };
}